// import React, { useState } from "react";
// import { NavLink } from "react-router-dom";
// import "./triangleApp.css";
// import triangle from "../../../assets/ecomm.png";
// // import triangle2 from "../../../assets/moblies7.png";
// import triangle2 from "../../../assets/newImg/mobile2.png";
// import Gpay from "../../../assets/gPay.png";
// import { LiaCheckCircleSolid } from "react-icons/lia";
// import QR from "../../../assets/QR.jpeg";
// const TriangleApp = () => {
//   const [activeUser, setActiveUser] = useState("vendor");
//   return (
//     <div className="container my-xxl-2 my-xl-2 my-lg-2 my-md-32my-sm-2 my-0 ">
//       <div className="row d-flex justify-content-between">
//         <div className="col-md-5 my-xl-0 my-lg-0  my-md-0 my-sm-2 my-2">
//           <img src={triangle2} alt="" className="triangleImg" />
//         </div>
//         <div className="col-md-6 my-xl-5 my-lg-5 my-2">
//           <h3 className="triH1 my-xl-3 my-lg-3  my-md-2 my-2">
//             Get Things Done Easily. Download the{" "}
//             <span className="triH1Span">Mestry Circle</span> App Today!
//           </h3>
//           <p className="triH2 my-xl-3 my-lg-2 my-md-2 my-2">
//             Book appointments, manage projects, and stay connected with service
//             providers - all on the go!
//           </p>
//           <div className="my-xl-3 my-lg-2 my-md-2 my-2">
//             {" "}
//             <p className="triP ">
//               <LiaCheckCircleSolid className="triangleIcon me-2" size={20} />
//               <span>Easy booking and appointment scheduling</span>
//             </p>
//             <p className="triP">
//               <LiaCheckCircleSolid className="triangleIcon me-2" size={20} />
//               <span>Get verified vendors</span>
//             </p>
//             <p className="triP">
//               <LiaCheckCircleSolid className="triangleIcon me-2" size={20} />
//               <span>Manage communication with service providers</span>
//             </p>
//           </div>

//           <div className="col-12 ">
//             <div className="d-flex justify-content-around  mt-xl-4 mt-lg-4  mt-2 mb-xl-2 mb-lg-2  mb-2">
//               <img
//                 src="https://hometriangle.com/images/svg/button-google-play.svg"
//                 alt=""
//                 className="triLogoImg mx-0"
//               />
//               <img
//                 src="https://hometriangle.com/images/svg/button-appstore.svg"
//                 alt=""
//                 className="triLogoImg"
//               />
//             </div>
//           </div>

//           <div className="d-flex justify-content-around gap-3 QRimg my-2">
//             <div className="">
//               <p className="triH3 text-center my-xl-3 my-lg-2 my-md-2 my-2">
//                 Vender
//               </p>{" "}
//               <div className="mobileFlex my-2">
//                 <img src={QR} alt="" className="qrImage mt-2 " />
//               </div>
//             </div>
//             <div className="">
//               <p className="triH3 text-center my-xl-3 my-lg-2 my-md-2 my-2">
//                 Customer
//               </p>{" "}
//               <div className="mobileFlex my-2">
//                 <img src={QR} alt="" className="qrImage mt-2" />
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default TriangleApp;

// import React, { useState } from "react";
// import { LiaCheckCircleSolid } from "react-icons/lia";
// import triangle2 from "../../../assets/newImg/mobile2.png";
// import QRVendorPlay from "../../../assets/QR.jpeg";
// import QRCustomerPlay from "../../../assets/QR.jpeg";
// import QRVendorApp from "../../../assets/QR.jpeg";
// import QRCustomerApp from "../../../assets/QR.jpeg";
// import "./triangleApp.css";

// const TriangleApp = () => {
//   const [activeStore, setActiveStore] = useState("googleplay");

//   const googlePlayImg =
//     "https://hometriangle.com/images/svg/button-google-play.svg";
//   const appStoreImg = "https://hometriangle.com/images/svg/button-appstore.svg";

//   return (
//     <div className="container my-xxl-5 my-xl-5 my-lg-2 my-md-3 my-sm-2 my-0">
//       <div className="row d-flex justify-content-between">
//         <div className="col-md-5 my-2 mobileDflex3 px-md-5 px-sm-5">
//           <img src={triangle2} alt="" className="triangleImg" />
//         </div>

//         <div className="col-md-6 my-xl-5 my-lg-5 my-2">
//           <h3 className="triH1 my-3">
//             Get Things Done Easily. Download the{" "}
//             <span className="triH1Span">Mestry Circle</span> App Today!
//           </h3>

//           <div className="d-flex justify-content-around mt-4 mb-3">
//             {/* Google Play */}
//             <div
//               className={`storeBtn ${
//                 activeStore === "googleplay" ? "activeStore" : ""
//               }`}
//               onClick={() => setActiveStore("googleplay")}
//             >
//               <img
//                 src={googlePlayImg}
//                 alt="Google Play"
//                 className="triLogoImg"
//               />
//             </div>

//             {/* App Store */}
//             <div
//               className={`storeBtn ${
//                 activeStore === "appstore" ? "activeStore" : ""
//               }`}
//               onClick={() => setActiveStore("appstore")}
//             >
//               <img src={appStoreImg} alt="App Store" className="triLogoImg" />
//             </div>
//           </div>

//           <div className="d-flex justify-content-around gap-3 QRimg my-2">
//             {/* Vendor */}
//             <div className="text-center">
//               <p className="triH3 my-2">Vendor</p>
//               <div className="mobileFlex my-2">
//                 <img
//                   src={
//                     activeStore === "googleplay" ? QRVendorPlay : QRVendorApp
//                   }
//                   alt="Vendor QR"
//                   className="qrImage mt-2"
//                 />
//               </div>
//             </div>

//             {/* Customer */}
//             <div className="text-center">
//               <p className="triH3 my-2">Customer</p>
//               <div className="mobileFlex my-2">
//                 <img
//                   src={
//                     activeStore === "googleplay"
//                       ? QRCustomerPlay
//                       : QRCustomerApp
//                   }
//                   alt="Customer QR"
//                   className="qrImage mt-2"
//                 />
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default TriangleApp;

// import React, { useState } from "react";
// import { FaAndroid, FaApple } from "react-icons/fa";
// import triangle2 from "../../../assets/newImg/mobile2.png";
// import QRVendorPlay from "../../../assets/QR.jpeg";
// import QRCustomerPlay from "../../../assets/QR.jpeg";
// import QRVendorApp from "../../../assets/QR.jpeg";
// import QRCustomerApp from "../../../assets/QR.jpeg";
// import "./triangleApp.css";

// const TriangleApp = () => {
//   const [activeStore, setActiveStore] = useState("googleplay");

//   const googlePlayImg =
//     "https://hometriangle.com/images/svg/button-google-play.svg";
//   const appStoreImg = "https://hometriangle.com/images/svg/button-appstore.svg";

//   const toggleStore = () => {
//     setActiveStore((prev) =>
//       prev === "googleplay" ? "appstore" : "googleplay"
//     );
//   };

//   return (
//     <div className="container my-xxl-5 my-xl-5 my-lg-2 my-md-3 my-sm-2 my-0">
//       <div className="row d-flex justify-content-between">
//         {/* Left side image */}
//         <div className="col-md-5 my-2 mobileDflex3 px-md-5 px-sm-5">
//           <img src={triangle2} alt="" className="triangleImg" />
//         </div>

//         {/* Right side content */}
//         <div className="col-md-6 my-xl-5 my-lg-5 my-2">
//           <h3 className="triH1 my-3">
//             Get Things Done Easily. Download the{" "}
//             <span className="triH1Span">Mestry Circle</span> App Today!
//           </h3>
//           <h3 className="triH3">
//             Choose your smartphone to download the Mestry Circle App.
//           </h3>
//           {/* Toggle Switch */}
//           <div className="toggleSwitch my-4" onClick={toggleStore}>
//             <div
//               className={`toggleKnob ${
//                 activeStore === "appstore" ? "right" : "left"
//               }`}
//             >
//               {activeStore === "googleplay" ? (
//                 <FaAndroid size={20} color="#3DDC84" />
//               ) : (
//                 <FaApple size={20} color="#000" />
//               )}
//             </div>

//             <div className="toggleLabels">
//               <span
//                 className={`toggleLabel ${
//                   activeStore === "googleplay" ? "active" : ""
//                 }`}
//               ></span>
//               <span
//                 className={`toggleLabel ${
//                   activeStore === "appstore" ? "active" : ""
//                 }`}
//               ></span>
//             </div>
//           </div>

//           {/* Display active store logo */}
//           <div className="text-center my-3">
//             <img
//               src={activeStore === "googleplay" ? googlePlayImg : appStoreImg}
//               alt="Store Logo"
//               className="triLogoImg"
//             />
//           </div>

//           {/* QR Codes */}
//           <div className="d-flex justify-content-around gap-3 QRimg my-2">
//             {/* Vendor */}
//             <div className="text-center">
//               <p className="triH3 my-2">Vendor</p>
//               <div className="mobileFlex my-2">
//                 <img
//                   src={
//                     activeStore === "googleplay" ? QRVendorPlay : QRVendorApp
//                   }
//                   alt="Vendor QR"
//                   className="qrImage mt-2"
//                 />
//               </div>
//             </div>

//             {/* Customer */}
//             <div className="text-center">
//               <p className="triH3 my-2">Customer</p>
//               <div className="mobileFlex my-2">
//                 <img
//                   src={
//                     activeStore === "googleplay"
//                       ? QRCustomerPlay
//                       : QRCustomerApp
//                   }
//                   alt="Customer QR"
//                   className="qrImage mt-2"
//                 />
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default TriangleApp;

// import React, { useState } from "react";
// import { FaAndroid, FaApple } from "react-icons/fa";
// import triangle2 from "../../../assets/newImg/mobile2.png";
// import QRVendorPlay from "../../../assets/QR.jpeg";
// import QRCustomerPlay from "../../../assets/QR.jpeg";
// import QRVendorApp from "../../../assets/QR.jpeg";
// import QRCustomerApp from "../../../assets/QR.jpeg";
// import "./triangleApp.css";

// const TriangleApp = () => {
//   const [activeStore, setActiveStore] = useState("googleplay");

//   const googlePlayImg =
//     "https://hometriangle.com/images/svg/button-google-play.svg";
//   const appStoreImg = "https://hometriangle.com/images/svg/button-appstore.svg";

//   const toggleStore = () => {
//     setActiveStore((prev) =>
//       prev === "googleplay" ? "appstore" : "googleplay"
//     );
//   };

//   return (
//     <div className="container my-xxl-5 my-xl-5 my-lg-2 my-md-3 my-sm-2 my-0">
//       <div className="row d-flex justify-content-between">
//         {/* Left side image */}
//         <div className="col-md-5 my-2 mobileDflex3 px-md-5 px-sm-5">
//           <img src={triangle2} alt="" className="triangleImg" />
//         </div>

//         {/* Right side content */}
//         <div className="col-md-6 my-xl-5 my-lg-5 my-2">
//           <h3 className="triH1 my-3 joinCText">
//             Get Things Done Easily. Download the{" "}
//             <span className="triH1Span">Mestry Circle</span> App Today!
//           </h3>
//           <h3 className="triH3 text-center">
//             Choose your smartphone to download the{" "}
//             <span className="triAppspan">Mestry Circle</span> App.
//           </h3>
//           {/* Toggle Switch */}
//           <div className="row d-flex ">
//             <div className="col-6 d-flex justify-content-center">
//               {" "}
//               <div
//                 className="toggleSwitch mt-xl-4 mt-lg-4 mt-md-3 mt-2 mb-0 "
//                 onClick={toggleStore}
//               >
//                 {/* mb-xl-1 mb-lg-1 mb-md-2 mb-2 */}
//                 <div
//                   className={`toggleKnob ${
//                     activeStore === "appstore" ? "right" : "right"
//                   }`}
//                 >
//                   {/* {activeStore === "googleplay" ? (
//                     <FaAndroid size={20} color="#3DDC84" />
//                   ) : (
//                     <FaApple size={20} color="#000" />
//                   )} */}
//                   {activeStore === "googleplay" ? (
//                     <>
//                       {" "}
//                       <FaApple size={20} color="#000" />
//                     </>
//                   ) : (
//                     <>
//                       {" "}
//                       <FaAndroid size={20} color="#3DDC84" />
//                     </>
//                   )}
//                 </div>

//                 {/* <div className="toggleLabels">
//                   <span
//                     className={`toggleLabel ${
//                       activeStore ===
//                       `googleplay   <p className="ms-3">switch to</p>`
//                         ? "active"
//                         : ""
//                     }`}
//                   ></span>

//                   <span
//                     className={`toggleLabel ${
//                       activeStore === "appstore" ? "active" : ""
//                     }`}
//                   ></span>
//                 </div> */}
//                 {/* <div className="toggleLabels">
//                   <span
//                     className={`toggleLabel ${
//                       activeStore === "googleplay" ? "active" : ""
//                     }`}
//                   >
//                     {activeStore === "googleplay" && (
//                       <p className="ms-4 mb-0">Switch to </p>
//                     )}
//                   </span>

//                   <span
//                     className={`toggleLabel ${
//                       activeStore === "appstore" ? "active" : ""
//                     }`}
//                   >
//                     {activeStore === "appstore" && (
//                       <p className="me-4 mb-0 ">Switch to </p>
//                     )}
//                   </span>
//                 </div> */}
//                 <div className="toggleLabels">
//                   <span
//                     className={`toggleLabel ${
//                       activeStore === "googleplay" ? "active" : ""
//                     }`}
//                   >
//                     {activeStore === "googleplay" && (
//                       <p className="me-1 mb-0  ">Switch to</p>
//                     )}
//                   </span>

//                   <span
//                     className={`toggleLabel ${
//                       activeStore === "appstore" ? "active" : ""
//                     }`}
//                   >
//                     {activeStore === "appstore" && (
//                       <p className="me-4 mb-0 ">Switch to </p>
//                     )}
//                   </span>
//                 </div>
//               </div>
//             </div>
//             <div className="col-6 ">
//               {" "}
//               <div className="text-center mt-xl-3 mt-lg-3 mt-md-2 mt-0 mb-2">
//                 <img
//                   src={
//                     activeStore === "googleplay" ? googlePlayImg : appStoreImg
//                   }
//                   alt="Store Logo"
//                   className="triLogoImg"
//                 />
//               </div>
//             </div>
//           </div>

//           {/* Display active store logo */}

//           {/* QR Codes */}
//           <div className="d-flex justify-content-around gap-3 QRimg mb-xl-2 mb-lg-2 mb-md-2 mb-1">
//             {/* Vendor */}
//             <div className="text-center">
//               <p className="triH3 my-xl-2 my-lg-2 my-1">Vendor</p>
//               <div className="mobileFlex my-2">
//                 <img
//                   src={
//                     activeStore === "googleplay" ? QRVendorPlay : QRVendorApp
//                   }
//                   alt="Vendor QR"
//                   className="qrImage mt-2"
//                 />
//               </div>
//             </div>

//             {/* Customer */}
//             <div className="text-center">
//               <p className="triH3 my-xl-2 my-lg-2 my-1">Customer</p>
//               <div className="mobileFlex my-2">
//                 <img
//                   src={
//                     activeStore === "googleplay"
//                       ? QRCustomerPlay
//                       : QRCustomerApp
//                   }
//                   alt="Customer QR"
//                   className="qrImage mt-2"
//                 />
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default TriangleApp;

// import React from "react";
// import triangle2 from "../../../assets/newImg/mobile2.png";

// import QRVendorPlay from "../../../assets/QR.jpeg";
// import QRVendorApp from "../../../assets/QR.jpeg";
// import QRCustomerPlay from "../../../assets/QR.jpeg";
// import QRCustomerApp from "../../../assets/QR.jpeg";

// import "./triangleApp.css";

// const TriangleApp = () => {
//   const googlePlayImg =
//     "https://hometriangle.com/images/svg/button-google-play.svg";
//   const appStoreImg = "https://hometriangle.com/images/svg/button-appstore.svg";

//   return (
//     <div className="container my-xxl-5 my-xl-5 my-lg-2 my-md-3 my-sm-2 my-0">
//       <div className="row d-flex justify-content-between">
//         {/* Left side image */}
//         <div className="col-md-5 my-2 mobileDflex3 px-md-5 px-sm-5">
//           <img src={triangle2} alt="" className="triangleImg" />
//         </div>

//         {/* Right content */}
//         <div className="col-md-6 my-xl-5 my-lg-5 my-2">
//           <h3 className="triH1 my-3 joinCText">
//             Get Things Done Easily. Download the{" "}
//             <span className="triH1Span">Mestry Circle</span> App Today!
//           </h3>

//           <h3 className="triH3 text-center">
//             Choose your QR to download the{" "}
//             <span className="triAppspan">Mestry Circle</span> App.
//           </h3>

//           {/* QR Section */}
//           <div className="d-flex justify-content-around gap-3 QRimg mb-xl-2 mb-lg-2 mb-md-2 mb-1">
//             {/* VENDOR */}
//             <div className="text-center">
//               <p className="triH3 my-xl-2 my-lg-2 my-1">Vendor</p>

//               {/* Play Store QR */}
//               <div className=" my-2">
//                 <img
//                   src={QRVendorPlay}
//                   alt="Vendor Play"
//                   className="qrImage mt-2"
//                 />
//                 <div className=" mt-2">
//                   <img
//                     src={appStoreImg}
//                     alt="App Store"
//                     className="triLogoImg"
//                   />
//                 </div>
//               </div>

//               {/* App Store QR */}
//               <div className=" my-2">
//                 <img
//                   src={QRVendorApp}
//                   alt="Vendor App Store"
//                   className="qrImage mt-2"
//                 />
//                 <div className="d-flex flex-column mt-2">
//                   <img
//                     src={googlePlayImg}
//                     alt="Google Play"
//                     className="triLogoImg mb-1"
//                   />
//                 </div>
//               </div>
//             </div>

//             {/* CUSTOMER */}
//             <div className="text-center">
//               <p className="triH3 my-xl-2 my-lg-2 my-1">Customer</p>

//               {/* Play Store QR */}
//               <div className=" my-2">
//                 <img
//                   src={QRCustomerPlay}
//                   alt="Customer Play"
//                   className="qrImage mt-2"
//                 />
//                 <div className="d-flex flex-column mt-2">
//                   <img
//                     src={appStoreImg}
//                     alt="App Store"
//                     className="triLogoImg"
//                   />
//                 </div>
//               </div>

//               {/* App Store QR */}
//               <div className=" my-2">
//                 <img
//                   src={QRCustomerApp}
//                   alt="Customer App Store"
//                   className="qrImage mt-2"
//                 />
//                 <div className="d-flex flex-column mt-2">
//                   <img
//                     src={googlePlayImg}
//                     alt="Google Play"
//                     className="triLogoImg mb-1"
//                   />
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default TriangleApp;

import React from "react";
import triangle2 from "../../../assets/newImg/mobile2.png";

import QRVendorPlay from "../../../assets/QR.jpeg";
import QRVendorApp from "../../../assets/QR.jpeg";
import QRCustomerPlay from "../../../assets/QR.jpeg";
import QRCustomerApp from "../../../assets/QR.jpeg";

import "./triangleApp.css";

const TriangleApp = () => {
  const googlePlayImg =
    "https://hometriangle.com/images/svg/button-google-play.svg";
  const appStoreImg = "https://hometriangle.com/images/svg/button-appstore.svg";

  return (
    <div className="container my-xxl-5 my-xl-5 my-lg-2 my-md-3 my-sm-2 my-0">
      <div className="row d-flex justify-content-between">
        {/* Left side image */}
        <div className="col-md-5 my-2 mobileDflex3 px-md-5 px-sm-5">
          <img src={triangle2} alt="" className="triangleImg" />
        </div>

        {/* Right content */}
        <div className="col-md-6 my-xl-5 my-lg-5 my-2">
          <h3 className="triH1 my-3 joinCText">
            Get Things Done Easily. Download the{" "}
            <span className="triH1Span">Mestry Circle</span> App Today!
          </h3>

          <h3 className="triH3 text-center">
            Choose your QR code to download the{" "}
            <span className="triAppspan">Mestry Circle</span> App.
          </h3>

          {/* QR Section */}

          <div className="row">
            <div className="col-12">
              {" "}
              <p className="triHeading mt-xl-4 mt-lg-4 mt-2 mb-xl-3 mb-lg-3 mb-1  text-center">
                Vendor
              </p>
            </div>
            <div className="col-6 d-flex justify-content-center">
              {" "}
              <div className=" my-xl-2 my-lg-2 my-1">
                <img
                  src={QRCustomerPlay}
                  alt="Customer Play"
                  className="qrImage mt-2"
                />
                <div className="d-flex flex-column mt-xl-3 mt-lg-3 mt-md-2 mt-1">
                  <p className="triPara my-xl-2 my-lg-2 my-1 text-center">
                    App store
                  </p>
                  <img
                    src={appStoreImg}
                    alt="App Store"
                    className="triLogoImg my-1"
                  />
                </div>
              </div>
            </div>
            <div className="col-6 d-flex justify-content-center">
              {" "}
              <div className=" my-xl-2 my-lg-2 my-1">
                <img
                  src={QRCustomerApp}
                  alt="Customer App Store"
                  className="qrImage mt-2"
                />
                <div className="d-flex flex-column mt-xl-3 mt-lg-3 mt-md-2 mt-1">
                  <p className="triPara my-xl-2 my-lg-2 my-1 text-center">
                    Google play
                  </p>
                  <img
                    src={googlePlayImg}
                    alt="Google Play"
                    className="triLogoImg my-1"
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-12">
              {" "}
              <p className="triHeading mt-xl-4 mt-lg-4 mt-2 mb-xl-3 mb-lg-3 mb-1 text-center">
                Coustomer
              </p>
            </div>
            <div className="col-6 d-flex justify-content-center">
              {" "}
              <div className="my-xl-2 my-lg-2 my-1">
                <img
                  src={QRCustomerPlay}
                  alt="Customer Play"
                  className="qrImage mt-2"
                />
                <div className="d-flex flex-column mt-xl-3 mt-lg-3 mt-md-2 mt-1">
                  <p className="triPara my-xl-2 my-lg-2 my-1 text-center">
                    App store
                  </p>
                  <img
                    src={appStoreImg}
                    alt="App Store"
                    className="triLogoImg my-1"
                  />
                </div>
              </div>
            </div>
            <div className="col-6 d-flex justify-content-center">
              {" "}
              <div className=" my-xl-2 my-lg-2 my-1">
                <img
                  src={QRCustomerApp}
                  alt="Customer App Store"
                  className="qrImage mt-2"
                />
                <div className="d-flex flex-column mt-xl-3 mt-lg-3 mt-md-2 mt-1">
                  <p className="triPara my-xl-2 my-lg-2 my-1 text-center">
                    Google play
                  </p>
                  <img
                    src={googlePlayImg}
                    alt="Google Play"
                    className="triLogoImg my-1"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TriangleApp;
